import React, { useState } from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import { SearchIcon, LocationIcon, HomeIcon, BedIcon, BathIcon, AreaIcon, FilterIcon } from '../components/Icons/Icons';
import './Rent.css';

function Rent() {
  const [filters, setFilters] = useState({
    city: '',
    propertyType: '',
    priceMin: '',
    priceMax: '',
    bedrooms: '',
    furnished: ''
  });

  const [showFilters, setShowFilters] = useState(false);

  const propertyTypes = ['House', 'Flat', 'Apartment', 'Studio', 'Room', 'Portion'];
  const bedroomOptions = ['1', '2', '3', '4', '5', '6+'];
  const furnishedOptions = ['Furnished', 'Semi-Furnished', 'Unfurnished'];

  // Mock rental properties data
  const rentalProperties = [
    {
      id: 1,
      title: '3 Bedroom Apartment for Rent',
      location: 'DHA Phase 5, Karachi',
      city: 'Karachi',
      type: 'Apartment',
      price: '75,000',
      bedrooms: 3,
      bathrooms: 3,
      area: '1400',
      furnished: 'Furnished',
      image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800&q=80'
    },
    {
      id: 2,
      title: 'Luxury 5 Marla House Available',
      location: 'Bahria Town, Lahore',
      city: 'Lahore',
      type: 'House',
      price: '120,000',
      bedrooms: 4,
      bathrooms: 4,
      area: '5 Marla',
      furnished: 'Semi-Furnished',
      image: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=800&q=80'
    },
    {
      id: 3,
      title: 'Modern 2 Bed Flat in F-10',
      location: 'F-10 Markaz, Islamabad',
      city: 'Islamabad',
      type: 'Flat',
      price: '65,000',
      bedrooms: 2,
      bathrooms: 2,
      area: '1100',
      furnished: 'Furnished',
      image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&q=80'
    },
    {
      id: 4,
      title: 'Studio Apartment Near Metro',
      location: 'Gulberg, Lahore',
      city: 'Lahore',
      type: 'Studio',
      price: '35,000',
      bedrooms: 1,
      bathrooms: 1,
      area: '550',
      furnished: 'Furnished',
      image: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800&q=80'
    },
    {
      id: 5,
      title: 'Spacious 4 Bed House',
      location: 'Clifton Block 2, Karachi',
      city: 'Karachi',
      type: 'House',
      price: '150,000',
      bedrooms: 4,
      bathrooms: 5,
      area: '2500',
      furnished: 'Semi-Furnished',
      image: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800&q=80'
    },
    {
      id: 6,
      title: 'Single Room with Attached Bath',
      location: 'Saddar, Rawalpindi',
      city: 'Rawalpindi',
      type: 'Room',
      price: '15,000',
      bedrooms: 1,
      bathrooms: 1,
      area: '200',
      furnished: 'Furnished',
      image: 'https://images.unsplash.com/photo-1540518614846-7eded433c457?w=800&q=80'
    }
  ];

  const handleSearch = () => {
    console.log('Searching with filters:', filters);
  };

  const handlePropertyClick = (propertyId) => {
    if (window.navigateTo) {
      window.navigateTo('rental-detail');
    }
  };

  return (
    <div className="rent-page">
      <Header />

      <div className="rent-container">
        <div className="rent-hero">
          <div className="rent-hero-content">
            <h1>Find Your Perfect Rental</h1>
            <p>Discover thousands of rental properties across Pakistan</p>
          </div>
        </div>

        <div className="rent-content">
          <div className="search-bar-section">
            <div className="search-bar-wrapper">
              <div className="search-input-group">
                <LocationIcon size={20} color="#636e72" />
                <input
                  type="text"
                  placeholder="Enter city, location or property name"
                  className="search-input"
                  value={filters.city}
                  onChange={(e) => setFilters({ ...filters, city: e.target.value })}
                />
              </div>
              <button className="btn-filter" onClick={() => setShowFilters(!showFilters)}>
                <FilterIcon size={20} color="#ffffff" />
                Filters
              </button>
              <button className="btn-search" onClick={handleSearch}>
                <SearchIcon size={20} color="#ffffff" />
                Search
              </button>
            </div>

            {showFilters && (
              <div className="filters-panel">
                <div className="filter-group">
                  <label className="filter-label">Property Type</label>
                  <select
                    value={filters.propertyType}
                    onChange={(e) => setFilters({ ...filters, propertyType: e.target.value })}
                    className="filter-select"
                  >
                    <option value="">All Types</option>
                    {propertyTypes.map(type => (
                      <option key={type} value={type}>{type}</option>
                    ))}
                  </select>
                </div>

                <div className="filter-group">
                  <label className="filter-label">Price Range (PKR/month)</label>
                  <div className="price-range">
                    <input
                      type="text"
                      placeholder="Min"
                      value={filters.priceMin}
                      onChange={(e) => setFilters({ ...filters, priceMin: e.target.value })}
                      className="filter-input"
                    />
                    <span className="price-separator">-</span>
                    <input
                      type="text"
                      placeholder="Max"
                      value={filters.priceMax}
                      onChange={(e) => setFilters({ ...filters, priceMax: e.target.value })}
                      className="filter-input"
                    />
                  </div>
                </div>

                <div className="filter-group">
                  <label className="filter-label">Bedrooms</label>
                  <div className="bedroom-options">
                    {bedroomOptions.map(option => (
                      <button
                        key={option}
                        className={`bedroom-option ${filters.bedrooms === option ? 'active' : ''}`}
                        onClick={() => setFilters({ ...filters, bedrooms: option })}
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="filter-group">
                  <label className="filter-label">Furnished Status</label>
                  <select
                    value={filters.furnished}
                    onChange={(e) => setFilters({ ...filters, furnished: e.target.value })}
                    className="filter-select"
                  >
                    <option value="">Any</option>
                    {furnishedOptions.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                </div>

                <button className="btn-clear-filters" onClick={() => setFilters({ city: '', propertyType: '', priceMin: '', priceMax: '', bedrooms: '', furnished: '' })}>
                  Clear All Filters
                </button>
              </div>
            )}
          </div>

          <div className="results-section">
            <div className="results-header">
              <h2>Available Rental Properties</h2>
              <p className="results-count">{rentalProperties.length} properties found</p>
            </div>

            <div className="properties-grid">
              {rentalProperties.map(property => (
                <div
                  key={property.id}
                  className="property-card"
                  onClick={() => handlePropertyClick(property.id)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === 'Enter' && handlePropertyClick(property.id)}
                >
                  <div className="property-image">
                    <img src={property.image} alt={property.title} />
                    <div className="property-badge">{property.furnished}</div>
                  </div>
                  <div className="property-content">
                    <div className="property-price">PKR {property.price}/month</div>
                    <h3 className="property-title">{property.title}</h3>
                    <div className="property-location">
                      <LocationIcon size={16} color="#636e72" />
                      <span>{property.location}</span>
                    </div>
                    <div className="property-features">
                      <div className="feature">
                        <BedIcon size={16} color="#636e72" />
                        <span>{property.bedrooms} Beds</span>
                      </div>
                      <div className="feature">
                        <BathIcon size={16} color="#636e72" />
                        <span>{property.bathrooms} Baths</span>
                      </div>
                      <div className="feature">
                        <AreaIcon size={16} color="#636e72" />
                        <span>{property.area} sqft</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="rental-info-section">
            <h2>Why Rent with PakMilkiyat?</h2>
            <div className="info-grid">
              <div className="info-card">
                <div className="info-icon">
                  <HomeIcon size={32} color="var(--color-primary)" />
                </div>
                <h3>Verified Properties</h3>
                <p>All rental listings are verified by our team for authenticity and accuracy.</p>
              </div>
              <div className="info-card">
                <div className="info-icon">
                  <FilterIcon size={32} color="var(--color-primary)" />
                </div>
                <h3>Smart Filters</h3>
                <p>Use advanced filters to find exactly what you need in your preferred location.</p>
              </div>
              <div className="info-card">
                <div className="info-icon">
                  <LocationIcon size={32} color="var(--color-primary)" />
                </div>
                <h3>Prime Locations</h3>
                <p>Properties available in all major cities and premium localities across Pakistan.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Rent;
